import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import ClientCompanyForm from '@galo-monitor/web-containers/forms/company/ClientCompanyForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const ClientCompanyModal = (props) => {
  const {
    id,
    open,
    handleClose,
    clientCompany,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    updatedFarmData => {
      handleClose()
      onSuccess(updatedFarmData)
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-farm',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t(isEmpty(clientCompany) ? 'register' : 'update')),
            this: toLower(t('company client', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, clientCompany, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('company client', { howMany: 1 })
      }) }
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <ClientCompanyForm
        ref={ formRef }
        clientCompany={ clientCompany }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

ClientCompanyModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  clientCompany: PropTypes.object
}

ClientCompanyModal.defaultProps = {
  clientCompany: {}
}

export default ClientCompanyModal
